import { Component, EventEmitter, Input, Output } from '@angular/core';
import { IFilterData, IFilterModel } from '../../models/filter-model';
import { ExameService } from '../../services/exame.service';
import { Filter } from '../../models/filter';
import { IExame } from '../../interfaces/exames/iexame';
import { map } from 'rxjs';
import { IFilter } from '../../interfaces/ifilter';

@Component({
  selector: 'split-filter-exam',
  templateUrl: './split-filter-exam.component.html',
  styleUrls: ['./split-filter-exam.component.scss']
})
export class SplitFilterExamComponent {
  public data: IFilterData[] = [];

  @Input() field!: string;
  @Input() label!: string;
  @Input() key!: string;

  @Output() onFilterEvent: EventEmitter<IFilterModel> = new EventEmitter<IFilterModel>();

  private filter = new Filter();

  constructor(private examService: ExameService) {

  }

  ngOnInit(): void {
    this.load();
  }

  load() {
    let filter = this.filter.convertFilterInQuery();
    this.examService.get(filter).pipe(
      map((exams: IExame[]) => exams.map(exam => ({ name: exam.name, id: exam.id as number } as IFilterData))),
    ).subscribe(
      (data: IFilterData[]) => {
        this.data = data;
      }
    )
  }

  onSearchDropdownChange($event: IFilter[]) {
    this.filter.setFilter($event[0].key as string, $event); 
    this.load();
  }


}
